export const transactionTableFetch = (params) => {
  return (dispatch) => {
    dispatch({ type: "TRANS_TABLE_FETCH", payload: params });
  };
};

export const transactionTablePreviousFetch = (params) => {
  return (dispatch) => {
    dispatch({ type: "TRANS_TABLE_PREV", payload: params });
  };
};

export const transactionTableContinuationToken = (params) => {
  return (dispatch) => {
    dispatch({ type: "TRANS_TABLE_CONT_TOKEN", payload: params });
  };
};
